import Cookies from 'js-cookie'

import { actionTypes } from './actionTypes'
import { initialState } from './initialState'
import { State, Action } from './types'
import { BEARER_TOKEN_COOKIE, ENV } from '../interfaces/constants'

const appReducer = (state: State = initialState, action: Action): State => {
  const { DEPLOY_ENV } = ENV
  const isDev = DEPLOY_ENV === 'development'

  switch (action.type) {
    case actionTypes.LOGIN:
      if (action.payload?.id) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ userID: `${action.payload.id}` })
      }
      return {
        ...state,
        authorizing: false,
        userInfo: action.payload,
        isLoggedIn: true,
      }
    case actionTypes.INIT_USER:
      return {
        ...state,
        userInfo: typeof state.userInfo === 'undefined' ? null : state.userInfo,
      }
    case actionTypes.LOGOUT:
      Cookies.remove(BEARER_TOKEN_COOKIE, {
        path: '/',
        domain: isDev ? 'localhost' : action.payload.domain,
      })
      return {
        ...state,
        authorizing: false,
        userInfo: null,
        isLoggedIn: false,
        communityJoined: [],
      }
    case actionTypes.ADD_COMMUNITY_JOINED: {
      const newCommunitiesState =
        typeof action.payload?.communityId === 'number'
          ? [...state.communityJoined, action.payload.communityId]
          : [...state.communityJoined]
      const newCommunities = action.payload?.communities || []
      return {
        ...state,
        communityJoined: [
          ...newCommunitiesState,
          ...newCommunities.filter((communityId: any) => {
            if (typeof communityId === 'number') {
              return newCommunitiesState.indexOf(communityId) !== -1
            }
            return false
          }),
        ],
      }
    }
    case actionTypes.REMOVE_COMMUNITY_JOINED: {
      return {
        ...state,
        communityJoined: state.communityJoined.filter((communityId) => {
          if (typeof action.payload?.communityId === 'number') {
            return action.payload.communityId === communityId
          }
          if (
            action.payload?.communities &&
            action.payload.communities?.length
          ) {
            return action.payload.communities.some((id: any) => {
              if (typeof id === 'number') {
                return id === communityId
              }
              return false
            })
          }
          return false
        }),
      }
    }
    case actionTypes.ADD_BOOKMARKS:
      if (!action.payload.bookmarks || !state.userInfo) return state
      const newBookmark = Array.from(
        new Set([...state.newBookmark, action.payload.bookmarkId]),
      )
      return {
        ...state,
        newBookmark,
        userInfo: {
          ...state.userInfo,
          bookmarks: Array.from(
            new Set(
              (state.userInfo.bookmarks || []).concat(action.payload.bookmarks),
            ),
          ),
          total_bookmark: (state.userInfo?.total_bookmark || 0) + 1,
          first_time_bookmark: Boolean(action.payload.isFirstTimeBookmark),
        },
      }
    case actionTypes.REMOVE_BOOKMARKS:
      if (!action.payload.bookmarks || !state.userInfo) return state
      const removeBookmarks = state.newBookmark.filter(
        (item) => item !== action.payload.bookmarkId,
      )
      return {
        ...state,
        newBookmark: removeBookmarks,
        userInfo: {
          ...state.userInfo,
          bookmarks: (state.userInfo.bookmarks || []).filter(
            (b) => !action.payload.bookmarks.includes(b),
          ),
          total_bookmark:
            (state.userInfo?.total_bookmark || 0) -
            (state.newBookmark.includes(action.payload.bookmarkId) ? 1 : 0),
        },
      }
    case actionTypes.SET_IS_MOBILE_SSR:
      return {
        ...state,
        isMobileSsr: action.payload.isMobileSsr,
      }
    case actionTypes.SET_OPEN_LOGOUT_POPUP:
      return {
        ...state,
        openLogoutPopup: action.payload.openLogoutPopup,
      }
    case actionTypes.SET_COMMENT_FOCUS:
      return {
        ...state,
        focusCommentId: action.payload.focusCommentId,
      }

    case actionTypes.SET_OPEN_DUE_DATE_POPUP:
      return {
        ...state,
        isOpenDueDatePopup: action.payload.isOpenDueDatePopup,
        dueDateRedirectLink: action.payload?.dueDateRedirectLink,
        dueDate: action.payload?.dueDate,
      }
    case actionTypes.PLAY_ARTICLE:
      return {
        ...state,
        articlePlayingId: action.payload.id,
      }

    case actionTypes.SET_OPEN_CONFIRM_LEAVE_PAGE_POPUP:
      return {
        ...state,
        showConfirmLeavePagePopup: action.payload,
      }

    case actionTypes.SET_CHATWOOT_WEBSITE_TOKEN:
      return {
        ...state,
        chatwootWebsiteToken: action.payload || '',
      }

    case actionTypes.SET_ZALO_CONFIG:
      return {
        ...state,
        zaloConfig: action.payload,
      }

    case actionTypes.SET_COLLECTING_ACTION:
      return {
        ...state,
        collectingAction: action.payload,
      }

    case actionTypes.SET_HEALTH_INFO:
      return {
        ...state,
        healthInfo: action.payload,
      }

    case actionTypes.UPDATE_CART:
      return {
        ...state,
        cartNumber: action.payload,
      }
    case actionTypes.UPDATE_USER_INFO: {
      return { ...state, userInfo: { ...state.userInfo, ...action.payload } }
    }
    default:
      return state
  }
}

export { appReducer }
